import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getOrderService,
  updateKitchenOrderStatusService,
} from '@/services/OrderServices';

import WaiterSection from './components/WaiterSection';

const POLL_MS = 8_000;

export default function WaiterBoard() {
  const dispatch = useDispatch();

  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  /* fetch only "Out for Delivery" */
  const load = useCallback(async () => {
    const { data: r } = await dispatch(
      getOrderService({ search: '', page: 1, limit: 300, extra_filter: {} })
    );
    const all = r?.data?.data ?? [];
    // filter on the fly:
    setOrders(all.filter(o => String(o.statusName).toUpperCase() === 'OUT_FOR_DELIVERY'));
  }, [dispatch]);

  const tRef = useRef(null);
  useEffect(() => {
    load();
    tRef.current = setInterval(load, POLL_MS);
    return () => clearInterval(tRef.current);
  }, [load]);

  const dineIn   = orders.filter(o => o.order_type === 2);
  const takeAway = orders.filter(o => o.order_type === 1);

  return (
    <div className="bg-[#F5F6FB] min-h-screen pt-6 pb-6 px-6 flex flex-col gap-6 overflow-hidden">
      {/* side-by-side Dine-In & Take-Away */}
      <WaiterSection
        dineIn={dineIn}
        takeAway={takeAway}
        expanded={expanded}
        onToggle={setExpanded}
        onDelivered={load}
        markDelivered={id =>
          dispatch(updateKitchenOrderStatusService(id, 6))
        }
      />
    </div>
  );
}
